import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import FruitCard from "./FruitCard";
import { PageSummary_SearchRequest } from "../Models/Model";
import { SimpleResponse } from "../Models/ResponseModel";
import pageService from "../Services/pageService";
import { PageType } from "../Models/Enum";
import { Col, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

function FruitCardList({ data, FldMapType }) {

    const [cardData, setCardData] = useState([]);

    useEffect(() => {
        getCardData();
    }, []);

    const getCardData = async () => {

        let req = new PageSummary_SearchRequest();

        req.PageTypeID = PageType.FruitDetail;
        req.ParentPageID = 3;

        try {
            let resp: SimpleResponse = await pageService.getInstance().PageSummary_Search(req);
            if (resp.HasError) {
                return;
            }

            setCardData(resp.Result);

        } catch (e) {

        }
    }



    return (
        <div className="row ps-2">
            <div className="col">


                <Container>
                    <Row xs={1} md={2} lg={3} xl={4} className="fruitCardList" >
                        {cardData.length > 0 && cardData.map((item, index) => (
                            <Col key={index} className='ps-2 pe-2 fruitfirstCard '>
                                <FruitCard item={item} />

                            </Col>
                        ))}
                    </Row>
                </Container>

               

            </div>
        </div>

    )
}

export default FruitCardList